import {formatDateMST} from "../../../../../utils/dateTImeHelper";
import {ExpandedOrder} from "../../../models/Models";

export function sanitizeOrders(orders: ExpandedOrder[]): ExpandedOrder[] {
  return orders.map((order) => {
    const formattedDate = formatDateMST(order.createdAt);
    return {
      ...order,
      createdAt: formattedDate,
    };
  });
}
